import { constants } from "../../../constants";

export default class OpenTable {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.openTable(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EZUGI:
                event["open_table"] = this._default;
                break;
            case constants.POKERSTARS:
                event["xc2rgShowPaytable"] = this._default;
                break;
            case constants.EDIG:
                event["openHTML"] = this._default;
                event["toggleMenu"]  = this._default;
                break;
            default:
                event["open_table"] = this._default;
                event["openPaytable"] = this._default;
        }

        return event;
    }
}
